import React from "react";
import SyncData  from "../modules/SyncData/Cards";
export default function SyncDataPage() {
  return <SyncData />;
}